// i18n area 'system' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.hy-AM.meta.json.
import type { enUS } from './system'

export const hyAM: typeof enUS = {
  diagnostics: {
    title: 'Ախտորոշում',
    subtitle: 'Ինչն է սխալ, ամենավատը՝ առաջինը — նույն ոսպնյակը, ինչ tvirt diagnose-ը',
    reload: 'Վերբեռնել',
    loadError: 'Ախտորոշումը չհաջողվեց կարդալ',
    exportBundle: 'Արտահանել փաթեթը',
    exportError: 'Փաթեթը չհաջողվեց ստեղծել',
    noProblem: 'Ստուգված տիրույթներում խնդիր չկա',
    nothingInspected: 'ՈՉԻՆՉ չի ստուգվել — սա առողջության վկայական չէ',
    inspected: 'Ստուգված',
    notInspected: 'ՉՍՏՈՒԳՎԱԾ',
    localHint: 'Հանգույցի լոկալ տիրույթները (systemd միավորներ, journal) կարդացվում են միայն CLI-ից. tvirt diagnose --area local — ուղին, երբ API-ն չի պատասխանում:',
    thresholds: 'ձախողված առաջադրանքներ {hours} ժ ընթացքում, heartbeat՝ ուշացած {seconds} վ-ից ավելի',
    severity: {
      critical: 'Կրիտիկական',
      warning: 'Զգուշացում',
      unknown: 'Անհայտ'
    }
  },
  explorer: {
    title: 'Ուսումնասիրել ռեսուրսները',
    root: 'Արմատ',
    empty: 'Այս սկոուպում ռեսուրսներ չկան',
    previewHint: 'Ընտրեք օբյեկտ՝ նախադիտումը տեսնելու համար',
    open: 'Բացել',

    // CRUD ցուցակների ?scope= խոր հղումը (ռաունդ #109), ուսումնասիրումից (#143):
    openScoped: 'Բացել ցուցակն այս սկոուպում',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM ձևանմուշ',
      ct: 'CT',
      ctTemplate: 'CT ձևանմուշ',
      app: 'Հավելված',
      overlayNetwork: 'Օվերլեյ ցանց',
      networkService: 'Ցանցային ծառայություն',
      fabric: 'Ֆաբրիկա',
      subnet: 'Ենթացանց',
      storage: 'Պահոցի պուլ',
      disk: 'Սկավառակ',
      catalogFile: 'Կատալոգի ֆայլ',
      ociRegistry: 'OCI ռեգիստր',
      ociImage: 'OCI պատկեր',
      cephCluster: 'Ceph կլաստեր',
      backupDestination: 'Կրկնօրինակման նպատակակետ',
      user: 'Օգտատեր',
      group: 'Խումբ',
      role: 'Դեր',
      credential: 'Հավատարմագրեր',
      tag: 'Թեգ',
      proximityRule: 'Մոտիկության կանոն'
    }
  },
  tags: {
    title: 'Թեգեր',
    empty: 'Թեգեր չկան',
    add: 'Ավելացնել թեգ',
    remove: 'Հեռացնել',
    name: 'Թեգ',
    value: 'Արժեք',
    save: 'Պահպանել',
    saveError: 'Չհաջողվեց պահպանել թեգերը',
    loadError: 'Չհաջողվեց բեռնել թեգերի բառապաշարը',
    noVocabulary: 'Այս տեսակի ռեսուրսի համար հասանելի թեգ չկա',

    // Արդեն սահմանված միարժեք թեգը պատասխանում է 409. փոխարինումը միշտ
    // բացահայտ է — երբեք ոչ անուղղակի (նախագծում, վավերացվել է 2026-07-27):
    overwrite: 'Փոխարինել ընթացիկ արժեքը',

    // Համակարգ > Թեգեր, բառապաշարի մակերեսը:
    createTitle: 'Ստեղծել թեգ',
    editTitle: 'Խմբագրել թեգը',
    nameHint: 'Տառեր, թվանշաններ, կետեր, գծիկներ և ընդգծումներ — ոչ «:», ոչ «/». tvirt- նախածանցը վերապահված է պլատֆորմին',
    cardinality: 'Կարդինալություն',
    cardinalitySingle: 'Միայն մեկ արժեք',
    cardinalityMultiple: 'Մի քանի արժեք',
    cardinalityHint: 'Մեկ արժեքի դեպքում թեգը վերանշանակելը խնդրում է փոխարինել այն',
    autoCreate: 'Արժեքների ինքնաստեղծում',
    autoCreateOn: 'Նշանակման պահին',
    autoCreateOff: 'Միայն հայտարարվածները',
    autoCreateHint: 'Միացված. նոր արժեք նշանակելը ստեղծում է այն։ Անջատված. նշանակվում են միայն հայտարարված արժեքները',
    values: 'Արժեքներ',
    noValues: 'Հայտարարված արժեք չկա',
    addValue: 'Ավելացնել արժեք',
    duplicateValue: 'Կրկնվող արժեք',
    kinds: 'Ռեսուրսի տեսակներ',
    kindsAll: 'Բոլորը',
    kindsPlaceholder: 'Բոլորը',
    kindsHint: 'Թողեք դատարկ՝ ամեն թեգավորելի ռեսուրսի տեսակ թույլատրելու համար',
    systemChip: 'Համակարգ',
    deleteCascade: 'Հեռացնել նաև նշանակումները',
    deleteCascadeHint: 'Դեռևս որևէ ռեսուրսի նշանակված պիտակը մերժվում է. այս ընտրանքով արժեքները և բոլոր նշանակումները հեռանում են պիտակի հետ միասին։'
  },
  scopes: {
    title: 'Սկոուպներ',
    createTitle: 'Ստեղծել սկոուպ',
    editTitle: 'Վերանվանել սկոուպը',
    path: 'Ուղի',
    segment: 'Հատված',
    segmentHint: 'Փոքրատառեր, թվանշաններ և գծիկներ (DNS-1123)',
    parent: 'Ծնող',
    rootChip: 'Արմատ',
    preview: 'Նոր սկոուպ',
    pickLabel: 'Սկոուպ',
    pickHint: 'Որտեղ է ապրում օբյեկտը կլաստերի ծառում — արմատը կամ vDC նրա ներսում։',
    ociCache: 'OCI քեշ (վերասահմանում)',
    appEphemeral: 'Հավելվածների անցողիկ պուլեր (վերասահմանում)',
    inherit: 'Ժառանգել',
    inheritsFrom: 'Ժառանգում է',
    inheritsCluster: 'Ժառանգում է կլաստերի լռելյայնը',
    inheritsNone: 'Ժառանգում է — գործող պուլ չկա',
    failoverProtection: 'Պաշտպանություն դեգրադացիայի ժամանակ',
    networkWeight: 'Ցանցի կշիռ',
    networkCeil: 'Ցանցի առաստաղ (Mbps)',
    protectionProtected: 'Պաշտպանված',
    protectionExpendable: 'Զոհաբերելի դեգրադացիայի ժամանակ',
    protectionDefault: 'Կլաստերի լռելյայն'
  },

  // Համակարգ > Տեղեկություններ (ռաունդ #124, 2026-07-31). պլատֆորմի
  // տարբերակները նավատորմում (առավելագույնը երկու՝ արդիականացման կեսին),
  // բաղադրիչներն ըստ հանգույցի, լոկալ մատուցվող PDF ձեռնարկը և լիցենզիայի քարտը:
  sysinfo: {
    summary: 'Պլատֆորմի տարբերակները կլաստերում, ամեն հանգույցի բաղադրիչները, կառավարման ձեռնարկը և լիցենզիան։',
    platformTitle: 'TVirt պլատֆորմ',
    platformSubtitle: 'Կլաստերի հանգույցների վրա դիտարկված տարբերակները',
    versionOnNodes: '{version}՝ {n} հանգույցի վրա',
    versionOnOneNode: '{version}՝ 1 հանգույցի վրա',
    mixedVersions: 'Կլաստերում պլատֆորմի մեկից ավելի տարբերակ կա — սպասելի է միայն ընթացիկ արդիականացման ժամանակ (առավելագույնը երկու)։',
    tooManyVersions: 'Կլաստերում պլատֆորմի երկուսից ավելի տարբերակ կա — դա երբեք սպասելի չէ, նույնիսկ արդիականացման ժամանակ. ստուգեք ստորև բերված հանգույցները։',
    unreportedNodes: 'Տարբերակների հաշվետվություն դեռ չկա՝ {nodes}',
    noVersionsYet: 'Ոչ մի հանգույց դեռ չի հայտնել իր տարբերակները։',
    nodesUnavailable: 'Հանգույցների ցուցակը ձեր թույլտվություններով տեսանելի չէ — պլատֆորմի տարբերակները ցուցադրել հնարավոր չէ։',
    colNode: 'Հանգույց',
    manualTitle: 'Կառավարման ձեռնարկ',
    manualSubtitle: 'Լոկալ պատճեն՝ մատուցվում է այս կլաստերից',
    manualBody: 'Ամբողջական TVirt ձեռնարկը PDF-ով, մատուցվում է անմիջապես պլատֆորմից — հասանելի է նաև air-gapped միջավայրերում։',
    manualLink: 'Կառավարման ձեռնարկ (PDF)',
    apiExplorerTitle: 'API զննիչ',
    apiExplorerSubtitle: 'OpenAPI պայմանագիրը՝ դիտարկելի',
    apiExplorerBody: 'Հարթակի ամբողջական OpenAPI պայմանագիրը — յուրաքանչյուր երթուղի, սխեմա և պատասխանի կոդ — դիտարկելի բրաուզերից, մատուցվում է այս հանգույցի միջոցով:',
    apiExplorerLink: 'Ուսումնասիրել API-ն',
    kubeTitle: 'Kubernetes-ի համատեղելիություն',
    kubeSubtitle: 'kubectl-ը և իր գործիքները՝ բնիկ API-ի առջև',
    kubeBody: 'TVirt KubeCompat-ը Pod-երը, Deployment-ները, Service-ները, namespace-ները, հանգույցները և իրադարձությունները նախագծում է Kubernetes-ի բարբառով — միայն ընթերցում, գումարած Deployment-ների ջնջում։ Յուրաքանչյուր կանչ անցնում է բնիկ API-ով քո թույլտվություններով. kubeconfig-ում որպես bearer օգտագործիր app token։',
    kubeEndpoint: 'Endpoint kubectl-ի համար',
    kubeStatusActive: 'Ակտիվ — Kubernetes {version}',
    kubeStatusMissing: 'Այս հանգույցում տեղադրված չէ (trantor-tvirt-kubecompat փաթեթ)',
    kubeStatusDown: 'Տեղադրված է, բայց չի պատասխանում — ստուգիր trantor-tvirt-kubecompat միավորը',
    kubeStatusChecking: 'Ստուգում…'
  },

  // Licensing (ռաունդ 2026-07-29). բաժանորդագրության լիցենզիայի էջը:
  licensing: {
    title: 'Կլաստերի լիցենզիա',
    subtitle: 'Բաժանորդագրության լիցենզիա — առավելագույնը մեկը ամեն կլաստերի',
    absentTitle: 'Գրանցված լիցենզիա չկա',
    absentBody:
      'Առանց վավեր լիցենզիայի կլաստերը մերժում է նոր վիրտուալ մեքենաների գործարկումը (միացված VM-ները մնում են միացված)։ Գրանցեք բաժանորդագրության հետ ստացած արտադրանքի բանալին։',
    registerButton: 'Գրանցել լիցենզիա',
    removeButton: 'Հեռացնել լիցենզիան',
    state: {
      ok: 'Վավեր',
      limitExceeded: 'Սահմանը գերազանցված',
      expired: 'Ժամկետանց'
    },
    productKeyLabel: 'Արտադրանքի բանալի',
    basisLabel: 'Սահմանի հիմքը',
    basis: {
      concurrentVms: 'Միաժամանակ միացված VM-ներ',
      physicalCores: 'Ֆիզիկական միջուկներ (կլաստերի ընդհանուր)'
    },
    limitLabel: 'Սահման',
    usageLabel: 'Ընթացիկ օգտագործում',
    usageOf: '{used}՝ {limit}-ից',
    usagePartial: 'մասնակի գումար — {n} հանգույց առանց դիտարկված CPU տոպոլոգիայի',
    usageUnknown: 'այս պահին դիտարկելի չէ',
    expiresLabel: 'Ժամկետ',
    neverExpires: 'երբեք',
    registeredLabel: 'Գրանցված',
    gateNote:
      'Բացակայող, ժամկետանց կամ սահմանը գերազանցած լիցենզիայի դեպքում կլաստերը մերժում է ՆՈՐ վիրտուալ մեքենաների գործարկումը։ Միացված VM-ները մնում են միացված, և HA վերագործարկումները չեն տուժում։',
    devStage:
      'Մշակման փուլ. արտադրանքի բանալին ընդունվում է այնպես, ինչպես կա, այստեղ հայտարարված սահմանների հետ միասին. ստորագրված բանալիով վալիդացիան կգա ապագա թողարկումով։',
    dialogTitle: 'Գրանցել լիցենզիա',
    dialogExpiresHelp: 'Դատարկ = լիցենզիան երբեք չի ժամկետանցվում',
    dialogSubmit: 'Գրանցել',
    dialogError: 'Չհաջողվեց գրանցել լիցենզիան։',
    removeTitle: 'Հեռացնել լիցենզիան',
    removeBody:
      'Կլաստերը կմնա ԱՌԱՆՑ ԼԻՑԵՆԶԻԱՅԻ. նոր վիրտուալ մեքենաները կմերժեն գործարկվել, մինչև նորը գրանցեք։ Միացված VM-ները մնում են միացված։',
    removeConfirm: 'Հեռացնել',
    removeError: 'Չհաջողվեց հեռացնել լիցենզիան։'
  },
  rbac: {
    tabRoles: 'Դերեր',
    tabGrants: 'Պատվիրակումներ',
    rolesTitle: 'Դերեր',
    createRoleTitle: 'Ստեղծել դեր',
    editRoleTitle: 'Խմբագրել դերը',
    nameHint: 'Փոքրատառեր, թվանշաններ և գծիկներ. tvirt- նախածանցը վերապահված է',
    systemChip: 'Համակարգ',
    permissions: 'Թույլտվություններ',
    permissionsPlaceholder: 'Ավելացնել թույլտվություն…',
    includedRoles: 'Ներառված դերեր',
    includedRolesPlaceholder: 'Ավելացնել դեր…',
    grantsTitle: 'Պատվիրակումներ',
    createGrantTitle: 'Ստեղծել պատվիրակում',
    principal: 'Principal',
    principalKind: 'Principal-ի տեսակ',
    principalUser: 'Օգտատեր',
    principalGroup: 'Խումբ',
    role: 'Դեր',
    grantRight: 'Պատվիրակում',
    grantRightChip: 'Կարող է պատվիրակել',
    grantRightLabel: 'Պատվիրակելու իրավունքով (ստացողն իր հերթին կարող է պատվիրակել այս դերը)',
    effective: 'Գործող',
    notEffective: 'Չգործող',
    createdAt: 'Ստեղծված',
    scopeHint: '/path՝ ճշգրիտ, /path/*՝ ռեկուրսիվ — պատվիրակումները խարսխվում են միակցված արմատին (/*-ը պատվիրակելի չէ)'
  },
  groups: {
    title: 'Խմբեր',
    createTitle: 'Ստեղծել խումբ',
    nameHint: 'Փոքրատառեր, թվանշաններ և գծիկներ. եզակի սկոուպում',
    members: 'Անդամներ',
    membersTitle: 'Անդամներ',
    membersPlaceholder: 'Ավելացնել օգտատեր…',
    noMembers: 'Անդամներ չկան',
    realmMappings: 'Ռեալմի քարտեզագրումներ',
    realmMappingsTitle: 'Ռեալմի քարտեզագրումներ',
    realmMappingsHint:
      'Ինչին է համապատասխանում այս խումբը ամեն արտաքին ռեալմում։ Անդամությունը կարդացվում է դիրեկտորիայից մուտքի պահին. դիրեկտորիայի խումբը, որն այստեղ ոչ ոք չի քարտեզագրում, անտեսվում է, և ներդրվածությունը չի լուծվում — այն պետք է հարթեցվի դիրեկտորիայի կողմում։',
    realm: 'Ռեալմ',
    externalGroup: 'Արտաքին խումբ',
    addRealmMapping: 'Ավելացնել քարտեզագրում',
    removeRealmMapping: 'Հեռացնել քարտեզագրումը',
    noRealmMappings: 'Ռեալմի քարտեզագրումներ չկան',

    // Բաժիններով ստեղծման երկխոսությունը (realm-wizard ռաունդ, 2026-08-03).
    // Ընդհանուր՝ գումարած արտաքին ռեալմների քարտեզագրման մակերեսը, խոսուն
    // դատարկ վիճակով:
    sectionGeneral: 'Ընդհանուր',
    mappingsNoRealms: 'Կարգավորված արտաքին ռեալմ չկա — քարտեզագրման մակերեսը բացվում է, հենց որ ռեալմ գոյություն ունենա։',
    mappingsNoRealmsLink: 'Բացել Ռեալմներ և SSO ներդիրը',

    // Խմբի պարտադրած MFA պահանջը (ռաունդ #178, կես B). մաքուր OR — խումբը
    // կարող է միայն ԱՎԵԼԱՑՆԵԼ պարտադրանքը, երբեք հանել:
    mfaRequired: 'MFA պարտադրանք',
    mfaRequiredChip: 'Պարտադրում է MFA',
    mfaNotRequiredChip: 'Պարտադրանք չկա',
    mfaRequiredHint:
      'Մաքուր OR. խումբը կարող է միայն ԱՎԵԼԱՑՆԵԼ երկրորդ գործոնի պարտադրանքն իր անդամներին — նաև արտաքին ինքնություններին՝ ռեալմի քարտեզագրումների միջոցով — երբեք հանել։ Ուժի մեջ է հաջորդ մուտքից. բաց սեանսները չեն փակվում։'
  },
  users: {
    title: 'Օգտատերեր',
    createTitle: 'Ստեղծել օգտատեր',
    editTitle: 'Խմբագրել օգտատիրոջը',
    username: 'Օգտանուն',
    usernameHint: 'Փոքրատառեր, թվանշաններ, կետեր և գծիկներ',
    displayName: 'Ցուցադրվող անուն',
    enabled: 'Ակտիվացված',
    state: 'Վիճակ',
    enabledChip: 'Ակտիվացված',
    disabledChip: 'Ապաակտիվացված',
    lockedChip: 'Արգելափակված',
    password: 'Գաղտնաբառ',
    passwordSetChip: 'Սահմանված',
    mustChangeChip: 'Փոխման ենթակա',
    initialPassword: 'Սկզբնական գաղտնաբառ',
    initialPasswordHint: 'Օգտատերը պետք է փոխի այն առաջին մուտքի ժամանակ',
    lastLogin: 'Վերջին մուտք',
    neverLoggedIn: 'Երբեք չի մտել',
    setPasswordTitle: 'Սահմանել գաղտնաբառ',
    setPasswordHint: 'Ադմինիստրատիվ փոխարինում — պահանջում է ձեր գաղտնաբառը (sudo ռեժիմ) և պարտադրում է օգտատիրոջը փոխել այն հաջորդ մուտքի ժամանակ։',
    operatorPassword: 'Ձեր գաղտնաբառը',
    unlock: 'Ապաարգելափակել հաշիվը',
    revokeTitle: 'Ետ կանչել սեանսները',
    revokeBody: 'Այս օգտատիրոջ բոլոր ակտիվ սեանսներն անմիջապես ավարտվում են։',
    revokeIncludeTokens: 'Ետ կանչել նաև հավելվածի թոքենները',
    revokeConfirm: 'Ետ կանչել',

    // Ստանդարտ երկխոսություն (ռաունդ #156). ամբողջական մանրամասներ, հաշիվ/անվտանգություն ներդիրներ:
    tabAccount: 'Հաշիվ',
    tabSecurity: 'Անվտանգություն',
    usernameImmutableHint: 'Օգտանունը հաշվի ինքնությունն է — ամրագրված ստեղծման պահին',
    groups: 'Խմբեր',
    noGroups: 'Խմբեր չկան',
    mustChangePassword: 'Գաղտնաբառի պարտադիր փոփոխություն',
    failedAttempts: 'Ձախողված մուտքի փորձեր',
    lockedUntil: 'Արգելափակված մինչև',

    // Identity ներդիրներ (2026-08-03). Համակարգ > Օգտատերերը դարձել է
    // ներդիրներով բաժին /system/rbac-ի մոդելով — օգտատերեր, խմբեր, արտաքին ռեալմներ:
    tabUsers: 'Օգտատերեր',
    tabGroups: 'Խմբեր',
    tabRealms: 'Ռեալմներ և SSO',
    tabMfa: 'MFA',

    // MFA ներդիր (task #178). երկրորդ գործոնի տեսքը։ Կես A — ըստ օգտատիրոջ
    // աղյուսակը users.yaml-ի վրա; կես B (contract ռաունդ, վավերացումներ
    // 2026-08-04) — գործող վճիռն իր ծագումով, արտաքին ակտիվացումները որբ
    // վիճակով և պարտադրանք պարտադրող խմբերը:
    mfa: {
      title: 'Երկրորդ գործոն (MFA)',
      methodsTitle: 'Հասանելի մեթոդներ',
      methodsSubtitle: 'Այն, ինչ այս տեղադրումը կարող է ստուգել որպես երկրորդ գործոն',
      methodsError: 'Չհաջողվեց բեռնել մեթոդների ռեգիստրը',
      builtinChip: 'Ներկառուցված',
      enrollableChip: 'Ակտիվացում TVirt-ում',
      delegatedChip: 'Կառավարվում է արտաքուստ',
      state: 'Վիճակ',
      stateActive: 'Ակտիվ',
      statePending: 'Ակտիվացման սպասում',
      stateNone: 'Չակտիվացված',
      required: 'MFA պարտադրանք',
      requiredChip: 'Պարտադիր',
      notRequiredChip: 'Ոչ պարտադիր',
      enrolledAt: 'Ակտիվացվել է',
      enrolledMethods: 'Ակտիվացված մեթոդներ',
      noMethods: 'Ակտիվացում չկա',
      codesRemaining: 'Մնացած վերականգնման կոդեր',
      resetTitle: 'Վերակայել երկրորդ գործոնը',
      resetHint:
        'Ակտիվացումը և բոլոր վերականգնման կոդերը զրոյացվում են. հաջորդ մուտքի ժամանակ օգտատերը կկատարի ակտիվացումը սկզբից։ MFA պարտադրանքը մնում է ինչպես կա — ադմինիստրատորը երբեք գաղտնիք չի սահմանում, միայն զրոյացնում է։',
      resetConfirm: 'Վերակայել',
      resetError: 'Չհաջողվեց վերակայել երկրորդ գործոնը',
      empty: 'Կառավարվող օգտատերեր դեռ չկան — հաշիվները հայտնվում են այստեղ, հենց որ գոյություն ունեն, ամեն մեկն իր երկրորդ գործոնի վիճակով։',

      // Կես B (ռաունդ #178). գործող վճռի ծագումը, արտաքին ակտիվացումները որբ
      // վիճակով, պարտադրանք պարտադրող խմբերը:
      viaSelf: 'Անձնական',
      viaSelfHint: 'Հաշվի անձնական ներդրումը (նրա դրոշը) — միակ մասը, որ մատիտը փոխում է։',
      viaGroupHint: 'Այս խմբից ժառանգված պարտադրանք. անձնական դրոշը հանելը չի ազատում օգտատիրոջը — միջամտում են խմբի վրա, Խմբեր ներդիրում։',
      subject: 'Ինքնություն',
      lastSeenAt: 'Վերջին հաստատում',
      enrollmentPending: 'Սպասման մեջ',
      orphanChip: 'Որբ',
      orphanDirectoryMiss: 'Ինքնությունն այլևս դիրեկտորիայում չէ',
      orphanRealmRemoved: 'Ռեալմը հեռացվել է TVirt-ից',
      orphanedAt: 'Որբ է սկսած',
      directoryUuid: 'UUID դիրեկտորիայում',
      externalTitle: 'Արտաքին ակտիվացումներ',
      externalEmpty: 'Արտաքին ակտիվացում դեռ չկա — այն ծնվում է MFA պարտադրանքով դիրեկտորիայի ինքնության առաջին մուտքի ժամանակ։',
      orphanHelp:
        'Որբ ակտիվացումը երբեք ինքն իրեն չի ջնջվում. այն անվտանգության նյութ է — մնում է աուդիտի համար, և եթե ինքնությունը նորից հայտնվի դիրեկտորիայում, կվերագտնի իր գործոնը։ Միակ ելքը ադմինիստրատիվ վերակայումն է։',
      visibilityHint: 'Արտաքին ակտիվացումներն ապրում են կլաստերի արմատում. դրանք տեսնում է միայն նա, ով ունի user.read ամբողջ ծառի վրա։',
      orphanResetHint:
        'Որբ տողը հեռացվում է վերջնականապես. այլևս ոչ ոք չի հավակնում դրան։ Եթե ինքնությունը նորից հայտնվի դիրեկտորիայում, ակտիվացումը կկատարի սկզբից։',
      enforcingTitle: 'MFA պարտադրող խմբեր',
      enforcingSubtitle:
        'Արտաքին ինքնությունների պարտադրանքի խարիսխը խումբն է. նրա ռեալմի քարտեզագրումներն ասում են, թե դիրեկտորիայի որ բնակչությանն է հասնում։ Արտաքին ակտիվացումը ծնվում է պարտադրված օգտատիրոջ առաջին մուտքի ժամանակ։',
      enforcingEmpty: 'Ոչ մի խումբ MFA չի պարտադրում — պարտադրանքը միացվում է խմբի վրա, Խմբեր ներդիրից։',
      enforcingError: 'Չհաջողվեց բեռնել MFA պարտադրող խմբերը'
    }
  },
  realms: {
    title: 'Նույնականացման ռեալմներ',
    createTitle: 'Ստեղծել ռեալմ',
    editTitle: 'Խմբագրել ռեալմը',
    name: 'Ռեալմ',
    nameHint: 'Դոմենը, որ օգտատերերը գրում են @-ից հետո (example.com) — ստեղծումից հետո անփոփոխ',
    nameImmutableHint: 'Ռեալմի անունը դրոշմված է ամեն սեանսում և աուդիտի ամեն տողում, որ երբևէ նշել է այն — վերանվանելը կվերագրեր պատմությունը',
    kind: 'Տեսակ',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC-ն և SAML-ը գալիս են առաջիկա ռաունդներով — այսօր ռեալմը LDAPv3 դիրեկտորիա է',

    // Ստեղծման կիսավարպետ (realm-wizard ռաունդ, 2026-08-03). քայլ 1-ի տեսակների
    // քարտերը — ldap-ը կենդանի, oidc/saml քարտերը ճանապարհային քարտեզում
    // (երբեք ձև առանց բեքենդի):
    kindCategory: 'Ռեալմի տեսակ',
    kindSelectHint: 'Ընտրեք դիրեկտորիայի տեսակը, որի վրա այս ռեալմը կնույնականացնի։',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Օգտանունն ու գաղտնաբառը ստուգվում են bind-ով LDAPv3 դիրեկտորիայի վրա — Active Directory, FreeIPA, OpenLDAP։'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on բրաուզերից՝ պատվիրակված OpenID Connect ինքնության պրովայդերին — գալիս է առաջիկա ռաունդներով։'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Կորպորատիվ single sign-on SAML 2.0 պնդումներով — գալիս է առաջիկա ռաունդներով։'
      }
    },
    tabBind: 'Bind',
    enabled: 'Ակտիվացված',
    urls: 'Դիրեկտորիայի սերվերներ',
    urlsHint: 'Մեկ ldap:// կամ ldaps:// URL ամեն տողում (1–8), փորձարկվում են հերթով — վթարային փոխարկում, երբեք հավասարակշռում',
    startTls: 'StartTLS',
    verifyCertificate: 'Ստուգել վկայագիրը',
    cleartextWarning: 'Առանց ldaps://-ի կամ StartTLS-ի bind-ի գաղտնաբառը ցանցով անցնում է բաց տեքստով — ընդունելի է լաբորատորիայում, երբեք արտադրությունում։',
    noVerifyWarning: 'Չստուգված TLS սեանսը ոչ մեկին չի նույնականացնում. ստուգումն անջատեք միայն այն դիրեկտորիայի հանդեպ, որը շտկել չեք կարող։',
    caCertificate: 'CA վկայագիր (PEM)',
    caCertificateHint: 'Ոչ պարտադիր CA փաթեթ՝ ամրացված այս ռեալմի TLS/StartTLS ձեռքսեղմման համար. դատարկը հեռացնում է այն',
    caCertificatePinned: 'Ամրացված',
    connectTimeout: 'Ժամանակահատված (վայրկյան)',
    connectTimeoutHint: 'Ըստ URL-ի միացման և հարցման ժամկետը (1–60). լրանալուն պես փորձարկվում է հաջորդ URL-ը',
    bindDn: 'Bind DN',
    bindDnHint: 'Ծառայողական հաշիվը, որը կատարում է օգտատիրոջ որոնումը. դատարկ = անանուն search bind (AD-ն մերժում է)',
    anonymousBind: 'Անանուն search bind',
    bindCredential: 'Bind գաղտնաբառ (բանալիների պահոց)',
    bindCredentialHint: 'usernamePassword գրառում բանալիների պահոցում bind գաղտնաբառով — գաղտնիքը երբեք չի ապրում ռեալմի վրա',
    bindCredentialNone: 'Ոչ մի (անանուն bind)',
    bindCredentialEmpty: 'Բանալիների պահոցում usernamePassword գրառում չկա — ստեղծեք մեկը Համակարգ > Հավատարմագրեր բաժնում bind գաղտնաբառի համար։',
    baseDn: 'Base DN',
    baseDnHint: 'Ենթածառը, որտեղից սկսվում է օգտատիրոջ որոնումը (DC=example,DC=com)',
    userFilter: 'Օգտատիրոջ զտիչ',
    userFilterHint: '%u-ն փոխարինվում է մուտքանվան լոկալ մասով՝ RFC 4515 escape-ով. ոչ-AD դիրեկտորիաները սովորաբար ուզում են (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf ատրիբուտ',
    memberOfAttributeHint: 'Կարդացվում է միայն մեկ անգամ՝ մուտքի պահին. չքարտեզագրված խմբերն անտեսվում են, ներդրվածությունը չի լուծվում',
    uuidAttribute: 'UUID ատրիբուտ',
    uuidAttributeHint: 'Ռեալմում անփոփոխ UUID-ն (objectGUID AD-ում, entryUUID OpenLDAP-ում) — դրոշմվում է աուդիտում օգտատեր@ռեալմ-ի կողքին',
    displayNameAttribute: 'Ցուցադրվող անվան ատրիբուտ',
    displayNameAttributeHint: 'Օգտագործվում է օգտատիրոջը ողջունելու համար. բացակայության դեպքում օգտագործվում է մուտքանունը',
    sudoHint: 'Ռեալմների վրա գրառումները sudo-պաշտպանված են. ռեալմը մուտքի դուռ է դեպի պլատֆորմ',
    deleteBody: 'Ռեալմի խմբերի քարտեզագրումները հեռանում են նրա հետ. նրա նույնականացրած սեանսները մնում են կենդանի մինչև ժամկետի ավարտը — ջնջված ռեալմը պարզապես այլևս ոչ մեկին ներս չի թողնում։',
    tabConnection: 'Միացում',
    tabDirectory: 'Դիրեկտորիա',
    testTitle: 'Փորձարկել միացումը',
    testHint: 'Կոնֆիգուրացիայի զոնդ, երբեք նույնականացում. միանում է, bind է անում ծառայողական հաշվով և — օգտանվան դեպքում — կատարում է օգտատիրոջ զտիչը։',
    testUsername: 'Օգտանուն (ոչ պարտադիր)',
    testUsernameHint: 'Լոկալ մաս, որի վրա կատարել օգտատիրոջ զտիչը — 1 համընկնումը առողջ պատասխանն է',
    testRun: 'Կատարել փորձարկումը',
    testError: 'Չհաջողվեց կատարել զոնդը',
    testReachable: 'Դիրեկտորիան հասանելի է, ծառայողական bind-ն ընդունված է',
    testUnreachable: 'Դիրեկտորիան ՀԱՍԱՆԵԼԻ ՉԷ',
    matchedOne: 'Օգտատիրոջ զտիչը գտավ ուղիղ 1 գրառում — առողջ պատասխանը։',
    matchedNone: 'Օգտատիրոջ զտիչը ոչ մի գրառում չգտավ. զտիչը կամ base DN-ը սխալ է։',
    matchedMany: 'Օգտատիրոջ զտիչը գտավ {count} գրառում. այն ընտրողական չէ, և մուտքերը կլինեին երկիմաստ (մերժված)։',
    mappingsPointer: 'Ինչին է համապատասխանում արտաքին խումբը, TVirt խմբի հատկությունն է (նրա ռեալմի քարտեզագրումները). ճշմարտության կետն ապրում է Խմբեր ներդիրում։',
    mappingsPointerLink: 'Բացել Խմբեր ներդիրը',
    rootHomeHint: 'Արտաքին ռեալմի ինքնություններն ապրում են կլաստերի արմատում, երբեք vDC-ում. թույլտվությունները նշանակվում են այնտեղ, որտեղ պետք են, պատվիրակումներով — խմբի վրա կամ ուղիղ օգտատիրոջ վրա, ճիշտ ինչպես բնիկների համար։'
  },
  credentials: {
    title: 'Հավատարմագրեր',
    createTitle: 'Ստեղծել հավատարմագրեր',
    editTitle: 'Խմբագրել հավատարմագրերը',
    kind: 'Տեսակ',
    kindUsernamePassword: 'Օգտանուն և գաղտնաբառ',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph ինքնություն)',
    kindHintUsernamePassword: 'Անփոփոխ։ CIFS/SMB պահոցների համար — միակցման հաշիվը, որի գաղտնիքը վորկերն օգտագործում է միակցման պահին։',
    kindHintIscsiChap: 'Անփոփոխ։ iSCSI CHAP նույնականացման համար — username = CHAP անուն, secret = CHAP գաղտնիք։',
    kindHintNvmeDhchap: 'Անփոփոխ։ NVMe over Fabrics-ի DH-HMAC-CHAP-ի համար — secret = DHHC-1:xx:… blob-ը. username-ը միայն պիտակ է։',
    kindHintCephx: 'Անփոփոխ։ Ceph կլիենտների համար — username = կլիենտի անուն (client.…), secret = base64 բանալին։',
    kindImmutableHint: 'Տեսակը ստեղծումից հետո անփոփոխ է — փոխելը նշանակում է նոր հավատարմագրեր։',
    username: 'Օգտանուն',
    usernameChap: 'CHAP անուն',
    usernameNvme: 'Պիտակ',
    usernameCephx: 'Կլիենտի անուն',
    usernameHint: 'Ոչ պարտադիր հաշիվ, որին պատկանում է գաղտնիքը',
    usernameHintChap: 'CHAP անունը, որով initiator-ը նույնականանում է',
    usernameHintNvme: 'Չի օգտագործվում տրանսպորտի կողմից — ազատ պիտակ ձեր նշումների համար',
    usernameHintCephx: 'cephx կլիենտի անունը — client. նախածանցը հանդուրժվում է',
    secret: 'Գաղտնիք',
    secretHint: 'Միայն գրելու համար. օգտագործվում է սպառողների կողմից, այլևս երբեք չի ցուցադրվում։',
    secretHintNvmeDhchap: 'Միայն գրելու համար. հոսթի DH-HMAC-CHAP գաղտնիքը կանոնական DHHC-1:xx:… ձևով — օգտագործվում է սպառողների կողմից, այլևս երբեք չի ցուցադրվում։',
    secretHintCephx: 'Միայն գրելու համար. base64 cephx բանալին — օգտագործվում է սպառողների կողմից, այլևս երբեք չի ցուցադրվում։',
    secretEditHint: 'Թողեք դատարկ՝ գաղտնիքը չփոխելու համար. լրացնելը ռոտացնում է այն։',
    createdAt: 'Ստեղծված',
    inUseError: "'{name}'-ին հղում է անում պահոցի կոնֆիգուրացիան — նախ ապակցեք այն այնտեղ։",
    nameHint: 'Փոքրատառեր, թվանշաններ և գծիկներ (DNS-1123). եզակի ըստ սկոուպի',

    // Միայն-ռոտացիայի երկխոսությունը (ռաունդ #156). գաղտնիքը երբեք ներդիր մատիտ չունի:
    rotateTitle: 'Գաղտնիքի ռոտացիա',
    rotateHint: 'Միայն գրելու համար. նոր գաղտնիքը փոխարինում է պահվածին — սպառողները կօգտագործեն այն հաջորդ միակցման ժամանակ։',

    // Ռաունդ #159 (PKI). Վկայագրեր և CA ներդիրները:
    tabSecrets: 'Գաղտնիքներ',
    tabCertificates: 'Վկայագրեր',
    tabAuthorities: 'Վկայագրման մարմիններ',
    certificatesTitle: 'Վկայագրեր',
    authoritiesTitle: 'Վկայագրման մարմիններ',
    caCreateTitle: 'Նոր CA',
    certCreateTitle: 'Նոր վկայագիր',
    caMode: 'Ծագում',
    caModeGenerate: 'Գեներացնել TVirt-ով',
    caModeImport: 'Ներմուծել (բանալի + վկայագիր)',
    certMode: 'Ծագում',
    certModeIssue: 'Թողարկել բանալիների պահոցի CA-ից',
    certModeImport: 'Ներմուծել (բանալի + վկայագիր)',
    issuingCa: 'Թողարկող CA',
    issuingCaHint: 'Վկայագիրը ծնվում է CA-ի սկոուպում՝ գրանցված ծնողով',
    noCasHint: 'Բանալիների պահոցում CA չկա — նախ գեներացրեք կամ ներմուծեք մեկը CA ներդիրում',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'CA-ի subject-ը. տառեր, թվանշաններ, բացատ, կետ, ընդգծում, գծիկ',
    commonNameCertHint: 'OpenVPN-ը կլիենտներին ճանաչում է CN-ով — պահեք այն եզակի ամեն CA-ի համար',
    days: 'Վավերականություն (օր)',
    daysCaHint: '1–7300 օր. 3650-ը (10 տարի) լռելյայնն է',
    daysCertHint: '1–3650 օր. 365-ը լռելյայնն է',
    keyType: 'Բանալու տեսակ',
    keyTypeHint: 'EC P-256-ը լռելյայնն է. RSA՝ legacy սպառողների համար',
    usage: 'Կիրառություն',
    usageClient: 'Կլիենտ (clientAuth)',
    usageServer: 'Սերվեր (serverAuth)',
    usageHint: 'Extended key usage-ը, որի համար վկայագիրը թողարկվում է',
    san: 'Այլընտրանքային անուններ (SAN)',
    sanHint: 'Ստորակետով բաժանված. IP արժեքները դառնում են IP: գրառումներ, մնացածը՝ DNS:',
    keyPem: 'Մասնավոր բանալի (PEM)',
    keyPemHint: 'Միայն գրելու համար. պահվում է բանալիների պահոցում, այլևս երբեք չի ցուցադրվում',
    certPem: 'Վկայագիր (PEM)',
    certPemHint: 'Հանրային վկայագիրը, որը զուգակցվում է բանալու հետ',
    certPemCaHint: 'CA վկայագիրը, որը զուգակցվում է բանալու հետ (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Թողարկող',
    parentCa: 'Թողարկող CA',
    parentCaImported: 'Ներմուծված — թողարկված TVirt-ից դուրս',
    serial: 'Սերիա',
    fingerprint: 'Մատնահետք (SHA-256)',
    validFrom: 'Վավեր է սկսած',
    validUntil: 'Վավեր է մինչև',
    expiry: 'Ժամկետ',
    expired: 'Ժամկետանց',
    expiresInDays: 'Ժամկետը լրանում է {days} օրից',
    revoked: 'Ետ կանչված',
    revokedAtLabel: 'Ետ է կանչվել',
    revokeTitle: 'Ետ կանչել վկայագիրը',
    revokeAction: 'Ետ կանչել',
    revokeWarning: 'Ետ կանչելը վերջնական է. սերիան մտնում է թողարկող CA-ի CRL, և ամեն սպառող, որ մերժում է ետ կանչված վկայագրերը (առաջին հերթին OpenVPN-ը), կմերժի սա։ Ապա-ետկանչում գոյություն չունի։',
    exportPem: 'Արտահանել PEM',
    exportChain: 'Արտահանել շղթայի փաթեթը',
    exportCrl: 'Արտահանել CRL',
    materialImmutableHint: 'X.509 նյութն անփոփոխ է — վերաթողարկեք կամ վերաներմուծեք',
    caInUseError: "'{name}'-ը դեռ ունի կենդանի թողարկված վկայագրեր (կամ պահոց է հղում անում նրան) — նախ ետ կանչեք կամ ջնջեք դրանք։"
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Տեղաբաշխում, հասանելիություն և աֆինություն — որտեղ են աշխատում կլաստերի VM-ները, և արդյոք դրանք պետք է միացված լինեն',
    loadError: 'Proximity պանելը պահանջում է կլաստերի կոնֆիգուրացիայի պահոցը — նավատորմի վիճակն այս պահին հասանելի չէ',
    config: {
      title: 'Կոնֆիգուրացիա',
      subtitle: 'Տեղաբաշխման քաղաքականություն կլաստերի մակարդակով',
      save: 'Պահպանել',
      saveError: 'Կոնֆիգուրացիան մերժվեց',
      strategy: 'Ընտրության ռազմավարություն',
      strategy_leastUsedResources: 'Ամենաքիչ օգտագործված ռեսուրսներ',
      strategy_leastVms: 'Ամենաքիչ VM-ներ',
      strategy_random: 'Պատահական',
      strategyLeastUsedResourcesHint: 'Վավեր թեկնածուների միջից՝ ամենաշատ մնացած օգտագործելի RAM ունեցող հանգույցը (դիտարկված ընդհանուր − հոսթի պահուստ − միացված VM-ներ), vCPU պարտավորությունը՝ որպես հավասարության լուծում։ Դետերմինիստական՝ նույն տվյալների դեպքում։',
      strategyLeastVmsHint: 'Վավեր թեկնածուների միջից՝ ամենաքիչ միացված VM ունեցող հանգույցը. հավասարությունները լուծվում են ըստ անվան։ Դետերմինիստական՝ նույն տվյալների դեպքում։',
      strategyRandomHint: 'Հավասարաչափ պատահական վավեր թեկնածուների միջից։',
      liveness: 'Հանգույցների կենսունակության շեմ (վայրկյան)',
      livenessHint: 'Շեմից ավելի լռող անդամն անհասանելի է. բացառվում է տեղաբաշխումից և — եթե սպասարկման մեջ չէ — HA որոշիչի կողմից համարվում է մեռած, որը ֆենսինգում է այն և նրա HA VM-ները վերագործարկում այլ տեղ։',
      decider: 'HA որոշիչ',
      deciderNone: 'դեռ չի ընտրվել'
    },
    nodesTitle: 'Հանգույցներ',
    nodesSubtitle: 'Կենսունակություն և էմպիրիկ տարողություն — օգտագործելի RAM = ընդհանուր − բազա − պարտավորված',
    nodeCol: 'Հանգույց',
    stateCol: 'Վիճակ',
    ramCol: 'RAM (ընդհանուր − բազա − պարտավորված)',
    usableCol: 'Օգտագործելի',
    vmsCol: 'Ծանրաբեռնվածություն',
    neverSeen: 'երբեք չի երևացել',
    freshChip: 'հասանելի',
    staleChip: 'անհասանելի',
    attestedChip: 'հաստատված անջատված',
    ramFormula: 'ընդհանուր − բազա − պարտավորված',
    haTitle: 'Բարձր հասանելիություն',
    haSubtitle: 'HA դրոշով VM-ները «միշտ միացված» են. TVirt-ը վերագործարկում է դրանք ամեն չպահանջված կանգից հետո — նույն հանգույցի վրա backoff-ով, այլ հանգույցի վրա, երբ իրենցը մեռնում է (միայն համօգտագործվող պահոց)։',
    haNone: 'Ոչ մի VM դեռ չունի HA դրոշ — ակտիվացրեք այն այստեղ կամ VM-ի մանրամասնում։',
    haVmCol: 'Վիրտուալ մեքենա',
    haStateCol: 'Վիճակ',
    haRestartsCol: 'HA վերագործարկումներ',
    haLastEventCol: 'Վերջին իրադարձություն',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA փոփոխությունը մերժվեց',
    rules: {
      title: 'Աֆինության կանոններ',
      createTitle: 'Նոր մոտիկության կանոն',
      editTitle: 'Խմբագրել կանոնը',
      nameHint: 'Փոքրատառեր, թվանշաններ և գծիկներ (DNS պիտակ)',
      vms: 'Վիրտուալ մեքենաներ',
      vmsHint: 'Առնվազն երկու VM — կանոնը սահմանում է, թե որտեղ են դրանք աշխատում միմյանց նկատմամբ',
      type: 'Տեսակ',
      affinity: 'Աֆինություն (միասին)',
      antiAffinity: 'Հակաաֆինություն (առանձին)',
      typeAffinityHint: 'VM-ները պետք է աշխատեն ՆՈՒՅՆ հանգույցի վրա։',
      typeAntiAffinityHint: 'VM-ները պետք է աշխատեն ՏԱՐԲԵՐ հանգույցների վրա — դասական HA զույգը։',
      mode: 'Ռեժիմ',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Խախտումները մերժում են գործողությունը (գործարկում, միգրացիա, վթարային փոխարկում)՝ խոսուն սխալով։',
      modeSoftHint: 'Նախապատվություն, երբեք արգելք. խախտումով տեղաբաշխումն առաջ է գնում տեսանելի նախազգուշացումով։',
      satisfied: 'Տեղաբաշխում',
      satisfiedYes: 'պահպանված',
      satisfiedNo: 'խախտված',

      // Ստանդարտ երկխոսություն (ռաունդ #156). խախտումներն ունեն իրենց տողը, ոչ թե tooltip:
      violations: 'Խախտումներ',
      noViolations: 'Չկան'
    },
    events: {
      title: 'HA իրադարձություններ',
      subtitle: 'Հասանելիության մատյանը — վերագործարկումներ, ֆենսինգ, վթարային փոխարկումներ և ազնիվ բացթողումները',
      none: 'Դեռ ոչինչ չկա։',
      when: 'Երբ',
      kind: 'Իրադարձություն',
      target: 'Օբյեկտ',
      detail: 'Մանրամասն',
      kindRestarted: 'HA վերագործարկում',
      kindGaveUp: 'հանձնվել է (crash loop)',
      kindNodeAttested: 'հանգույցը ֆենսինգված է',
      kindFailedOver: 'վթարային փոխարկում',
      kindNoCandidate: 'թեկնածու չկա',
      kindStorageLocalSkip: 'բաց թողնված (լոկալ պահոց)',
      kindZombieFenced: 'զոմբին վերացված է'
    }
  }
}
